<template>
    <div
        ref="nedglobePreviewPanel"
        :class="[
            mode === 'preview' ? 'preview-pane' : '',
            userSettings.previewzoom > 100 ? 'snap-left' : ''
        ]"
    >
        <div :class="[previewAreaSize ? '' : 'init', 'print-extras']">
            <div
                v-show="previewAreaSize && previewConfig"
                :style="paperSizeStyle"
                class="print-page-preview"
            >
                <div class="print-pane" :style="paperSizeScaleStyle">
                    <div ref="extraPanel" class="print-overlay">
                        <div ref="extraElement" class="extra-element">
                            <print-result-table
                                :previewConfig="previewConfig"
                                :mode="mode"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PrintResultTable from './PrintResultTable.vue';

    export default {
        name: 'PrintExtras',
        components: { 'print-result-table': PrintResultTable },
        props: {
            previewConfig: { type: Object, required: true },
            mode: { type: String, required: true },
            userSettings: { type: Object, required: true }
        },
        data() {
            return {
                previewAreaSize: null,
                originalSize: null,
                originalResolution: null,
                displayScale: 1
            };
        },
        mounted() {
            this.$_onStart();
        },
        methods: {
            $_onStart() {
                this.previewAreaSize = {
                    width: this.$refs.nedglobePreviewPanel.clientWidth,
                    height: this.$refs.nedglobePreviewPanel.clientHeight
                };
            },
            $_setPreviewScale() {
                if (this.mode === 'preview') {
                    this.displayScale =
                        this.scale * (this.userSettings.previewzoom / 100);
                } else {
                    this.displayScale = 1;
                }
            }
        },
        watch: {
            mode() {
                this.$_setPreviewScale();
            },
            scale() {
                this.$_setPreviewScale();
            },
            'userSettings.previewzoom': '$_setPreviewScale'
        },
        computed: {
            scale: function () {
                if (!(this.previewConfig && this.previewAreaSize)) {
                    return 1;
                }
                const rectRatio =
                    this.previewConfig.paper.width /
                    this.previewConfig.paper.height;
                const boundsRatio =
                    this.previewAreaSize.width / this.previewAreaSize.height;
                return rectRatio > boundsRatio
                    ? this.previewAreaSize.width / this.previewConfig.paper.width
                    : this.previewAreaSize.height / this.previewConfig.paper.height;
            },
            paperSizeStyle: function () {
                if (this.mode === 'preview') {
                    return {
                        width: `${
                            this.previewConfig.paper.width * this.displayScale
                        }px`,
                        height: `${
                            this.previewConfig.paper.height * this.displayScale
                        }px`
                    };
                }
                return {};
            },
            paperSizeScaleStyle: function () {
                if (this.mode === 'preview') {
                    return {
                        width: `${this.previewConfig.paper.width}px`,
                        'min-height': `${this.previewConfig.paper.height}px`,
                        transform: `scale(${this.displayScale})`
                    };
                }
                const scale = this.printScale;
                return {
                    'min-width': `${
                        this.previewConfig.paper._props.width * (1 / scale)
                    }mm`,
                    transform: `scale(${scale})`
                };
            }
        }
    };
</script>

<style scoped lang="scss">
.init {
    position: absolute;
    width: 100%;
    height: 100%;
}
.preview-pane {
    height: 80vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: visible;
}
.preview-pane.snap-left {
    overflow: auto;
    align-items: initial;
}
.print-overlay {
    position: absolute;
    pointer-events: none;
}

.print-page-preview {
    position: relative;
    overflow: hidden;
    border: 2px solid black;
}
.snap-left {
    align-self: start;
}
.print-pane {
    position: absolute;
    transform-origin: left top;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}
.extra-element {
    background-color: white;
    width: 100%;
    height: 100%;
    display: flex;
}
@media print {
    .print-pane {
        position: relative;
    }
    .print-overlay {
        position: relative;
        pointer-events: unset;
    }
    .print-extras {
        .print-page-preview {
            overflow-x: hidden;
            overflow-y: visible;
            border: none;
            transform-origin: left top;
        }
    }
    .page-margin {
        border: none;
    }
}
</style>
